<template>
    <div>
       
        <!-- Page header -->
        <section>
            <div class="centric-hold-80">
                <div class="wrapp-rt2">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><h2 class="main-head1">Genamet Customer Portal Home</h2></div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><p class="sub-head1 pull-right"><span><a href="#">Click here</a></span></p></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Page header ends -->      

        <!-- Select Service Step -->
        <section>
            <div class="centric-hold-80">
                <div class="wrapp-rt2">
                    <div class="row mt-50">
                        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">

                            The Site is down for maintenance. Please try again later. Sorry about the inconvenience! 

                        </div>                        
                    </div>
                </div>
            </div>
        </section>
        <!-- Select Service Step ends -->
    </div>
</template>

<script>
export default {
  name: "HomePage"
};
</script>

<style>
</style>
